// `audio.tts`: speech, a voice reading the prompt (G7-sound-types).
// Live's Sounds page chip; the Sounds forms build these. Sound takes no source.
import { AudioTtsQuote, AudioTtsRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";
import { commonFields } from "./shared";

export const jobType: JobTypeModule<"audio.tts"> = {
  type: "audio.tts",
  label: "Text-to-speech",
  source: "form",
  pair: "audio.tts",
  fields: (draft) => commonFields(draft),
  request: AudioTtsRequest,
  quote: AudioTtsQuote,
};
